var offline_mode = false; // true or false
var user_group_id = "1793";
var user_group_name = "";
var user_group_ua_property_id = ""; // GA Linker - Variable
var offline_url = "https://www.officeworksphotos.com.au/pages/offline";
var reimagine_url = "https://www.officeworks.com.au/photos-and-photo-gifts/";
var poster_url = "https://www.officeworks.com.au/photos-and-photo-gifts/product/posters/";
var legacy_url = "https://www.officeworks.com.au/photos-and-photo-gifts/imagine/app.php?userGroupID=";
var api_url = "//rest.fujifilmimagine.com";

function fullWin(imagine_id) {
	var win;

	// GA Linker - gaLink is added to redirect links
	if (offline_mode == true) {
		// offline mode
		win = window.location.href = offline_url;
	} else if (imagine_id == "#" || imagine_id == "" || imagine_id == undefined) {
		// imagine id hasn't been passed
		win = window.location.href = reimagine_url;
	} else if (imagine_id.slice(-1) == "#") {
		// product redirect for posters
		win = window.location.href = poster_url + imagine_id.slice(0,-1);
	} else {
		// product redirect for reimagine
		win = window.location.href = reimagine_url + "product-redirect?productId=" + imagine_id;
	}
	
	if (window.focus) {
		win.window.focus();
	}
}
/*
function getProductPrice(imagine_id, shopify_id) {
	jQuery.ajax({
		url: api_url + "/api/product/" + imagine_id,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.product[0] != undefined) {
				// api returned a result
				if (data.product[0].promo_price > 0 && data.product[0].price != data.product[0].promo_price) {
					// promo price exists
					$('#promo_' + shopify_id).show();
					$('#promo_' + shopify_id).html("&#36;" + data.product[0].price);
					$('#product_' + shopify_id).html("&#36;" + data.product[0].promo_price);
                    $('#product_' + shopify_id).css({"color": "red"});
					$('#expires_' + shopify_id).show();
					$('#expires_' + shopify_id).html("Ends " + data.product[0].promo_ends);
				} else {
					// no promo exists
					$('#promo_' + shopify_id).hide();
					// check if product price exists before overwriting
					if (data.product[0].price > 0) {
						$('#product_' + shopify_id).html("&#36;" + data.product[0].price);
					}
                    $('#expires_' + shopify_id).hide();
                    $('#product_' + shopify_id).removeClass("on-sale-wrapper");
				}
				//console.log(imagine_id + "," + shopify_id + "," + data.product[0].price + "," + data.product[0].promo_price);
			}
		},
		error: function(jqXHR, status) {
			//console.log(status);
		}
	});
}
*/
function getDeliveryEstimate(postcode) {
	jQuery.ajax({
		url: "//rest.fujifilmimagine.com/api/delivery/" + postcode,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.delivery[0] != undefined) {
				// api returned a result
                $('#delivery_form').hide();
                $('#delivery_submit').show();
                $('#delivery_region').html(data.delivery[0].suburb + " " + postcode + ", " + data.delivery[0].state);
                $('#delivery_instore').html(data.delivery[0].instore);
                $('#delivery_standard').html(data.delivery[0].standard);
                $('#delivery_express').html(data.delivery[0].express);
                $('#delivery').show();
				//console.log(imagine_id + "," + shopify_id + "," + data.product[0].price + "," + data.product[0].promo_price);
			}
		},
		error: function(jqXHR, status) {
			//console.log(status);
		}
	});
}